import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGrid',
  setup(__props) {

const GridOptions = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridOptions.vue"))
const GridColumm = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridColumm.vue"))
const GridAlignment = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridAlignment.vue"))
const GridSection = defineAsyncComponent(() => import("@/components/theme/uikits/grid/GridSection.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(GridOptions)),
      _createVNode(_unref(GridColumm)),
      _createVNode(_unref(GridAlignment)),
      _createVNode(_unref(GridSection))
    ])
  ]))
}
}

})